import CoreConfig from "../../config/index"
import { makeid } from '../../helpers/CoreHelpers'

let Settings = null;

try {
    Settings = require('./../../../projectSettings');
    Settings = Settings.Settings();
} catch (e) {
    Settings = null;
}

const full = window.location.protocol+'//'+window.location.hostname+(window.location.port ? ':'+window.location.port: '')+"/";

export default {
    'version': CoreConfig.version,
    'authorization': (Settings && Settings.admin.authorization !== null && typeof (Settings.admin.authorization) !== "undefined") ? Settings.admin.authorization : CoreConfig.authorization,
    'name': process.env.APP_NAME,
    'api': {
        'endpoint': process.env.API_ENDPOINT,
        'cdn': process.env.CDN_ENDPOINT,
        getCdnEndPoint() {
            if (this.cdn) {
                return this.cdn
            } else {
                return this.endpoint;
            }
        }
    },
    'language': process.env.LANGUAGE,
    'prefix': 'csod-awave--',
    'adminURL': document.getElementById('application').getAttribute('data-admin-url') ? document.getElementById('application').getAttribute('data-admin-url') : full,
    'frontURL': document.getElementById('application').getAttribute('data-front-url') ? document.getElementById('application').getAttribute('data-front-url') : full,
    'client': document.getElementById('application').getAttribute('data-client'),
    'renderer': document.getElementById('application').getAttribute('data-renderer'),
    'initialRoute': document.getElementById('application').getAttribute('data-initial-route'),
    destroy: CoreConfig.destroy,
    set: CoreConfig.set,
    get: CoreConfig.get,
    clearStorage: CoreConfig.clearStorage,
    setToken: CoreConfig.setToken,
    getToken: CoreConfig.getToken,
    setUser: CoreConfig.setUser,
    getUser: CoreConfig.getUser,
    getApiConfig: CoreConfig.getApiConfig,
    getId: CoreConfig.getId,
    getStoragePrefixes: CoreConfig.getStoragePrefixes,
    generateId: CoreConfig.generateId,
    getSsoLink(ssoId) {
        let id = ssoId ? ssoId : makeid();
        this.setSsoId(id);

        if (Settings.admin.ssoUrlBase) {
        	return Settings.admin.ssoUrlBase + id;
        } else {
	        return CoreConfig.getSsoLink();
        }
    },
    getSsoId: CoreConfig.getSsoId,
    setSsoId: CoreConfig.setSsoId,
    settings: Settings,
    getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },
    getCurrentCsodSessionGuid(){
        return this.getCookie("SessionGuid");
    },
};


// WEBPACK FOOTER //
// ./src/core/admin/config/index.js